import { createTheme } from '@mui/material/styles';
import { filledInputClasses } from '@mui/material';

// #0096d6
const primary = '#0096d6';
const primaryLight = '#0096d6';
const primaryDark = '#007db3';

// #ff9102
const secondary = '#ff9102';
const secondaryLight = '#ffb24f';
const secondaryDark = '#cc7400';

// #d32f2f
const error = '#d32f2f';
const errorLight = '#ef5350';
const errorDark = '#c62828';

// #05aa05
const success = '#05aa05';
const successLight = '#17d133';
const successDark = '#2e7d32';

const disabled = '#9f9f9f';

export const ThemeBlue = createTheme({
  typography: {
    fontFamily: `"Roboto", sans-serif`,
    fontSize: 16,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: 'white',
          backgroundColor: secondary,
          width: 'auto',
          boxShadow: '1px 1px 5px grey',
          paddingLeft: '25px',
          paddingRight: '25px',
          borderRadius: '15px',
          '&:disabled': {
            color: 'white',
            backgroundColor: disabled,
            boxShadow: '1px 1px 5px grey',
          },
          ':hover': {
            backgroundColor: secondaryDark,
            boxShadow: '1px 1px 5px grey',
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: '12px',
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: 'white',
          ':hover': {
            backgroundColor: 'white',
          },
          [`&.${filledInputClasses.focused}`]: {
            backgroundColor: 'white',
          },
        },
        input: {
          ':autofill': {
            borderRadius: 'inherit',
          },
        },
      },
    },
  },
  palette: {
    background: {
      default: primary,
    },
    primary: {
      light: primaryLight,
      main: primary,
      dark: primaryDark,
      contrastText: '#ffffff',
    },
    secondary: {
      light: secondaryLight,
      main: secondary,
      dark: secondaryDark,
      contrastText: '#ffffff',
    },
    success: {
      light: successLight,
      main: success,
      dark: successDark,
    },
    error: {
      light: errorLight,
      main: error,
      dark: errorDark,
    },
    rootContainer: {
      color: '#ffffff',
      background: primary,
    },
    button: {
      primary: {
        color: '#ffffff',
        background: secondary,
        backgroundHover: secondaryDark,
      },
      apple: {
        color: '#000000',
        background: '#ffffff',
        backgroundHover: '#eeeeee',
      },
      confirm: {
        background: success,
        backgroundHover: successDark,
      },
      cancel: {
        background: error,
        backgroundHover: errorDark,
      },
    },
    menu: {
      color: '#ffffff',
      background: '#71c1e4',
    },
    progress: {
      circular: {
        primary: primary,
        secondary: secondary,
      },
      linear: {
        primary: secondary,
        secondary: '#ffd7a3',
      },
    },
    infoIcon: primary,
    dialog: {
      title: {
        color: '#ffffff',
        background: primary,
      },
      primaryButton: {
        color: '#ffffff',
        background: secondary,
        backgroundHover: secondaryDark,
        backgroundDisabled: disabled,
      },
    },
    appBar: {
      top: {
        color: '#ffffff',
        background: primary,
      },
      bottom: {
        color: '#ffffff',
        background: primary,
      },
    },
    textLink: primary,
    card: {
      primary: {
        color: '#ffffff',
        background: primary,
      },
      secondary: {
        color: '#ffffff',
        background: secondary,
      },
    },
    breadcrumbs: {
      color: '#ffffff',
    },
  },
});
